import React from "react";
import pxToRem from "~libs/pxToRem";

interface ContentSectionProps {
  children?: React.ReactNode;
}

const ContentSection: React.FC<ContentSectionProps> = ({ children }) => {
  return (
    <section
      style={{
        width: "100%",
        maxWidth: pxToRem(500),
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
      }}
    >
      {children}
    </section>
  );
};

export default ContentSection;
